import React, {useEffect, useState} from "react";
import {Card} from "react-bootstrap";
import AdminService from "../../services/admin.service";
import store from "../../store/store";
import {getClientOptions, RESET_ACTION} from "../canopia/CanopiaUtils";
import {useDispatch, useSelector} from "react-redux";
import {loadAllClients, selectUserState} from "../../reducer/userSlice";
import Select from "react-select";
import ajaxloader from "../../images/ajax-loader.gif";

export default function Reload(props) {

    const dispatch = useDispatch();

    // Loading data
    const [loadStatus, setLoadStatus] = useState('idle');
    // Data loaded on page load
    const {allClients, error} = useSelector(selectUserState);

    // Options for dropdowns
    const [clientOptions, setClientOptions] = useState([]);

    // Form
    const [clientOption, setClientOption] = useState(null);

    // Reload
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [errorName, setErrorName] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);


    // Load all the clients to populate the dropdown (done only once)
    useEffect(() => {
        if (loadStatus === "idle") {
            setLoadStatus("pending");
            try {
                dispatch(loadAllClients());
            } catch (err) {
                setLoadStatus("error");
                // setLoadMessage("An error occurred while loading the page");
            } finally {
                setLoadStatus("success");
            }
        }
    }, [loadStatus, dispatch]);

    useEffect(() => {
        setClientOptions(getClientOptions(allClients));
    }, [allClients]);


    const handleReload = (e) => {
        e.preventDefault();

        setLoading(true);
        setErrorName(null);
        setErrorMessage(null);

        AdminService.reload(clientOption ? clientOption.value : null)
            .then(
                response => {
                    setMessage(response.data.message);
                    setLoading(false);
                    setTimeout(() => setMessage(null), 3000);
                    store.dispatch(RESET_ACTION);
                },
                error => {
                    setLoading(false);
                    processError(error);
                }
            );
    }

    const handleSelectClient = (client, action) => {
        setClientOption(client);
    }

    const processError = (error) => {
        let response = error.response;

        let errorName;
        let errorMessage;
        if (response &&
            response.data &&
            response.data.error &&
            response.data.message) {
            errorName = response.data.error;
            errorMessage = response.data.message;
        } else {
            errorName = 'Service unavailable';
            errorMessage = 'We apologize for the inconvenience, our team is working on solving the issue. Please try to come back in a few minutes.\nThank you for your patience.';
            if (error.message) {
                console.log(error.message);
            }
        }

        setErrorName(errorName);
        setErrorMessage(errorMessage);
    }

    return (
        <div className="main-content">
            <Card style={{width: '50vw', margin: 'auto'}}>
                <Card.Body>
                    <Card.Title className='canopia'>Reload</Card.Title>

                    <form onSubmit={handleReload}>
                        <p>Clear the cache of Canopia and refresh client data</p>
                        <p>Select a specific client or leave blank to refresh all clients</p>
                        <ul>
                            <li>Canopia data (ESG checks) of all clients + clear cache of Top positions screen</li>
                            <li>Conser data (Consensus & ISINs): to display Direct Lines/Real Estate tabs and Top
                                positions screen
                            </li>
                            {/*<li>Fund & Benchmark look-through: to compute ESG checks</li>*/}
                        </ul>


                        {(loadStatus === "idle" || loadStatus === "pending") &&
                            <div style={{margin: "1rem auto"}}>
                                <img alt="loading" src={ajaxloader}/>
                            </div>
                        }
                        {loadStatus === "error" &&
                            <div className="dashboard">
                                <header className="jumbotron">
                                    <h3 className='canopia'>{error ? error.error : 'Error'}</h3>
                                    <p>{error ? error.message : 'An error occurred while processing your request. If the problem persists, please contact our support team (support@canopia.ch)'}</p>
                                </header>
                            </div>}
                        {loadStatus === 'success' &&
                            <div className={'setup-form-input'}>
                                <Select options={clientOptions}
                                        isClearable
                                        isSearchable={true}
                                        closeMenuOnSelect={false}
                                        onChange={handleSelectClient}/>
                            </div>}

                        <div className="form-group" style={{marginTop: "2rem"}}>
                            <button className="btn btn-primary btn-block" disabled={loading}>
                                {loading && (
                                    <span className="spinner-border spinner-border-sm" style={{marginRight: '5px'}}/>
                                )}
                                <span>Reload</span>
                            </button>
                        </div>

                        {message && (
                            <div className="form-group">
                                <br/>
                                <div className={"alert alert-success"} role="alert">
                                    {message}
                                </div>
                            </div>
                        )}

                        {errorName && (
                            <div className="form-group">
                                <div className={"alert alert-danger"} role="alert">
                                    <h3 className='canopia'>{errorName}</h3>
                                    {errorMessage}
                                </div>
                            </div>
                        )}
                    </form>
                </Card.Body>
            </Card>
        </div>
    );
}
